<template>
	<div class="page">
		<Navigation pageName="scriptsinventory" />
		<!--FILTRI E RICERCA-->
		<form class="filter-section" @submit.prevent="getScripts(true)">
			<div class="filter-left">
				<label class="text-bold">{{ $t("Search") }}</label>
				<input class="input pl-2 select  text-small" v-model="filters.strToSearch" type="text" :placeholder="$t('Search for Device name')" />
			</div>

			<div class="filter-left">
				<label class="text-bold">{{ $t("OS") }}</label>
				<select class="select text-small w-auto px-2" v-model="filters.os">
					<option value="">{{ $t("Show all") }}</option>
					<option v-for="(os, id) in ScriptsHelper.osValues" :value="id">{{ os }}</option>
				</select>
			</div>
			<div class="filter-left">
				<label class="text-bold">{{ $t("Language") }}</label>
				<select class="select text-small w-auto px-2" v-model="filters.lang">
					<option value="">{{ $t("Show all") }}</option>
					<option v-for="(lang, id) in ScriptsHelper.languagesValues" :value="id">{{ lang }}</option>
				</select>
			</div>
			<div class="filter-left">
				<label class="text-bold">{{ $t("Status") }}</label>
				<select class="select text-small w-auto px-2" v-model="filters.status">
					<option value="">{{ $t("Show all") }}</option>

					<option v-for="(status, id) in ScriptsHelper.statusValues" :value="id">{{ $t(status) }}</option>
				</select>
			</div>

			<div class="filter-left d-flex flex-align-end">
				<button type="submit" class="button secondary">
					{{ $t('Filter') }}
				</button>
			</div>
		</form>
		<!--RISULTATI-->
		<div class="results-section">
			<table class="table border striped m-0 bg-white">
				<thead>
					<tr>
						<th class="sortable-column" tabindex="0" :aria-sort="ariaSort('name')" @click="toggleSort('name')" @keydown.enter.space.prevent="toggleSort('name')">
							{{ $t("Name") }}
							<span v-if="sortKey === 'name'" class="ml-1" :class="sortDirection === 'asc' ? 'mif-sort-asc' : 'mif-sort-desc'"></span>
						</th>
						<th>{{ $t("Description") }}</th>
						<th class="sortable-column" tabindex="0" :aria-sort="ariaSort('status')" @click="toggleSort('status')" @keydown.enter.space.prevent="toggleSort('status')">
							{{ $t("Status") }}
							<span v-if="sortKey === 'status'" class="ml-1" :class="sortDirection === 'asc' ? 'mif-sort-asc' : 'mif-sort-desc'"></span>
						</th>
						<th class="text-center">{{ $t("Language") }} / {{ $t("OS") }}</th>
						<th class="sortable-column" tabindex="0" :aria-sort="ariaSort('inserted_at')" @click="toggleSort('inserted_at')" @keydown.enter.space.prevent="toggleSort('inserted_at')">
							{{ $t("Created at") }}
							<span v-if="sortKey === 'inserted_at'" class="ml-1" :class="sortDirection === 'asc' ? 'mif-sort-asc' : 'mif-sort-desc'"></span>
						</th>
						<th class="sortable-column" tabindex="0" :aria-sort="ariaSort('updated_at')" @click="toggleSort('updated_at')" @keydown.enter.space.prevent="toggleSort('updated_at')">
							{{ $t("Updated at") }}
							<span v-if="sortKey === 'updated_at'" class="ml-1" :class="sortDirection === 'asc' ? 'mif-sort-asc' : 'mif-sort-desc'"></span>
						</th>
						<th>{{ $t("Tags") }}</th>
						<!--<th>{{ $t("Version") }}</th>-->
						<th></th>
					</tr>
				</thead>
				<tbody>
					<tr v-if="loading">
						<td colspan="8" class="text-center p-5">
							<span class="mif-spinner2 fg-primary ani-spin mif-3x" />
						</td>
					</tr>
					<tr v-else-if="scripts.length === 0">
						<td colspan="8">
							<NoDataAvailable :message="$t('No scripts available')" />
						</td>
					</tr>
					<template v-else>
						<tr v-for="script in sortedScripts" :key="script.id" class="mx-8 p-4 rounded m-6">
							<td>
								<a class="text-bold text-left place-left m-0 button flat-button" style="min-width: unset;" :href="'#' + script.id">
									{{ script.name }}
								</a>
							</td>
							<td>
								{{ script.description }}
							</td>
							<td>
								{{ $t(ScriptsHelper.statusValues[script.status]) }}
							</td>
							<td>
								<div class="script-table-info text-center">
									<div class="my-2">
										<span class="badge inline script-detail-badge script-detail-language">{{ ScriptsHelper.languagesValues[script.language] }}</span>
									</div>
									<div>
										<span class="badge inline script-detail-badge script-detail-os">{{ ScriptsHelper.osValues[script.os] }}</span>
									</div>
								</div>
							</td>
							<td>
								{{ script.inserted_at.toLocalDate() }}
							</td>
							<td>
								{{ script.updated_at.toLocalDate() }}
							</td>
							<td>
								<span v-for="tag in script.tags" class="badge inline tertiary mr-1">{{ tag }}</span>
							</td>
							<td>
								<ul class="listview flex-justify-end d-flex">
									<li class="button flat-button" :class="{ disabled: script.status === 'draft' }" :title="script.status === 'draft' ? $t('Draft scripts cannot be deployed') : $t('Deploy')" @click="deployScript(script)">
										<span class="mif-2x mif-rocket"></span>
									</li>
									<li class="button flat-button" :title="$t('Edit')" @click="openDialogScript(script.id)">
										<span class="mif-2x mif-pencil"></span>
									</li>

									<li class="button flat-button" :title="$t('Delete')" @click="deleteScript(script)">
										<span class="mif-2x mif-2x mif-bin"></span>
									</li>
								</ul>
							</td>
						</tr>
					</template>
				</tbody>
			</table>
		</div>
	</div>
</template>
<script>
import Navigation from '../components/utils/Navigation';
import NoDataAvailable from "../components/utils/NoDataAvailable.vue";
import { DefaultObjectBuilder } from '../models/DefaulfObjectBuilder.js';
import { ScriptsHelper } from '../utils/objects';
import { waitSeconds } from '../utils/utilitiesmodule';
export default {
	name: "Scripts",
	props: {
		idScript: String
	},
	components: {
		Navigation,
		NoDataAvailable
	},
	watch: {
		'$route': {
			handler: function (to, from) {
				/*if (to.hash != "" && to.hash.endsWith("/delete")) {
					var scriptID = to.hash.split("/")[0].replace("#", "");
					this.deleteScript(scriptID);
					return;
				}*/
				if (to.hash != "") {
					var id = to.hash.replace("#", "");
					this.openDialogScript(id)
				}
			},
			deep: true,
			immediate: true
		}
	},
	data() {
		return {
			scripts: [],
			allScripts: [],
			loading: true,
			sortKey: null,
			sortDirection: null,
			filters: {
				strToSearch: "",
				os: "",
				lang: "",
				status: ""
			},
			ScriptsHelper: ScriptsHelper

		}
	},
	computed: {
		sortedScripts() {
			if (!this.sortKey) {
				return this.scripts;
			}

			const key = this.sortKey;
			const direction = this.sortDirection === 'asc' ? 1 : -1;
			return [...this.scripts].sort((first, second) => {
				if (key === 'inserted_at' || key === 'updated_at') {
					return (this.dateTimestamp(first[key]) - this.dateTimestamp(second[key])) * direction;
				}

				const firstValue = key === 'status'
					? this.$t(this.ScriptsHelper.statusValues[first.status] || '')
					: first[key];
				const secondValue = key === 'status'
					? this.$t(this.ScriptsHelper.statusValues[second.status] || '')
					: second[key];

				return String(firstValue || '').localeCompare(
					String(secondValue || ''),
					undefined,
					{ sensitivity: 'base', numeric: true }
				) * direction;
			});
		}
	},
	mounted: function () {
		this.$session.setRoomPC(null);
		this.$root.socket("SETPC", null);
		this.$root.$on("refreshScripts", this.refreshScripts);
		this.getScripts(false);
	},
	beforeDestroy: function () {
		this.$root.$off("refreshScripts", this.refreshScripts);
	},
	methods: {
		async refreshScripts() {
			await this.getScripts(false);
		},
		toggleSort(key) {
			if (this.sortKey === key) {
				this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc';
				return;
			}

			this.sortKey = key;
			this.sortDirection = ['inserted_at', 'updated_at'].includes(key) ? 'desc' : 'asc';
		},
		ariaSort(key) {
			if (this.sortKey !== key) {
				return 'none';
			}
			return this.sortDirection === 'asc' ? 'ascending' : 'descending';
		},
		dateTimestamp(value) {
			const timestamp = value ? new Date(value).getTime() : 0;
			return Number.isNaN(timestamp) ? 0 : timestamp;
		},
		toShow(script) {
			var a = this.filters.strToSearch == "" || script.name.contains(this.filters.strToSearch) || script.description.contains(this.filters.strToSearch) || script.tags.some(t => t.contains(this.filters.strToSearch));

			if (!a) {
				return false;
			}

			return ["", script.os].includes(this.filters.os) && ["", script.language].includes(this.filters.lang) && ["", script.status].includes(this.filters.status);
		},
		async getScripts(applyFilters) {

			if (applyFilters) {
				var strToSearch_toLower = this.filters.strToSearch.toLowerCase();
				this.scripts = this.allScripts.filter(s => this.filterMethod(s, strToSearch_toLower));
				return;
			}

			this.loading = true;
			try {
				this.allScripts = await this.$api.getScripts();
				this.scripts = [...this.allScripts];
			} finally {
				this.loading = false;
			}
		},

		filterMethod(script, strToSearch_toLower) {

			var simpleFilters = ["", script.status].includes(this.filters.status) &&
				["", script.language].includes(this.filters.lang) &&
				["", script.os].includes(this.filters.os);

			if (!simpleFilters) {
				return false;
			}

			var containsStrToSearch = this.filters.strToSearch == '' ||
				script.name.toLowerCase().contains(strToSearch_toLower) ||
				script.description.toLowerCase().contains(strToSearch_toLower) ||
				script.tags.any(t => t.toLowerCase().contains(strToSearch_toLower));

			return containsStrToSearch;
		},


		openDialogScript(id) {
			this.$router.push({ name: 'script', params: { idScript: String(id) } });
		},
		
		async deleteScript(script) {
			//Personalizzo la dialog da mostrare
			var dialogID = Math.floor(100000 + Math.random() * 900000).toString();
			var dialogTitle = this.$t("Delete Script");
			var dialogContent = this.$t('deleteConfirmation', { 0: script.name });

			let self = this;
			this.$root.$on(dialogID, async ok => {
				self.$root.$off(dialogID);
				if (!ok) {
					return;
				}
				ok = await self.$api.deleteScript(script.id, script.name);

				//Se la cancellazione del gruppo non va a buon fine, riporto l'URL a /scripts
				if (!ok) {
					return;
				}
				await self.refreshScripts();
			});

			//Avvio la richiesta che mi risponderà con un $emit
			this.$root.openYesNoDialog(dialogID, dialogTitle, dialogContent);
		},
		deployScript(script) {
			if (!script || script.status === 'draft') return;
			this.$root.$emit('OPENSCRIPTDEPLOYDIALOG', script.id);
		}
	}
}
</script>
<style scoped>
.script-table-info {
	line-height: 1.45;
	white-space: nowrap;
}

.sortable-column {
	cursor: pointer;
	user-select: none;
}

.sortable-column:hover {
	background-color: #f4f6f8;
}

.script-table-label {
	color: #777;
	display: inline-block;
	min-width: 78px;
}

.script-detail-badge {
	min-width: 82px;
	text-align: center;
}

.script-detail-status {
	background-color: #eff6ff;
	border-color: #bfdbfe;
	color: #2563eb;
}

.script-detail-language {
	background-color: #f0fdf4;
	border-color: #bbf7d0;
	color: #16a34a;
}

.script-detail-os {
	background-color: #fef2f2;
	border-color: #fecaca;
	color: #dc2626;
}
</style>
